import Top from '@/views/Top.vue'
import MenuList from '@/views/MenuList.vue'
import Search from '@/views/Search.vue'
import SearchByKeyword from '@/views/SearchByKeyword.vue'
import SearchByCategory from '@/views/SearchByCategory.vue'
import MenuModify from '@/views/MenuModify.vue'
import Calculation from '@/views/Calculation.vue'
const Screen = {
  Top: Top,
  MenuList: MenuList,
  Search: Search,
  SearchByKeyword: SearchByKeyword,
  SearchByCategory: SearchByCategory,
  MenuModify: MenuModify,
  Calculation: Calculation
}

export default Screen
